import { Card, CardContent, Typography } from "@mui/material";

interface InfoCardProps {
  title: string;
  subtitle: string;
}

const InfoCard: React.FC<InfoCardProps> = ({ title, subtitle }) => {
  return (
    <Card sx={{ borderRadius: 2, boxShadow: 2 }}>
      <CardContent>
        <Typography variant="subtitle1" fontWeight="bold">
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default InfoCard;
